import Model from "./base/model";

class CorreiosModalTransport extends Model {
  resourceName() {
    return "correios_modals_transport";
  }

  fields() {
    return {
      correios_code: "",
      correios_description: "",
      correios_segment_code: "",
      correios_segment_description: "",
      integra_modal_transport: "",

      shippers: ""
    };
  }
}
export default new CorreiosModalTransport();
